<template>
  <div class="padding7 el-card">
    <el-form :model="voucherQueryModel" label-width="120px" label-position="left">
      <div>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="品牌" label-width="80px">
              <el-select
                v-model="voucherQueryModel.brandID"
                placeholder="选择品牌"
                size="mini"
                class="width100"
                @change="brandChange"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-show="brandSel">
            <el-form-item label="门店" label-width="50px">
              <el-select
                v-model="voucherQueryModel.storeID"
                placeholder="选择门店"
                size="mini"
                class="width100"
                @change="storeChange"
              >
                <el-option
                  v-for="item in storesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="生成日期" label-width="80px">
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                size="mini"
                style="width:100%"
                @change="timeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="top7">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              class="pull-right"
              @click="deleteBatch"
              :disabled="!storeSel"
            >批量删除</el-button>
            <el-button
              type
              size="mini"
              icon="el-icon-search"
              class="pull-right right-20"
              @click="search"
              :disabled="!storeSel"
            >查询</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-table
      :data="tableData"
      size="mini"
      style="width: 100%;"
      border
      ref="tableData"
      @select="tableSelectHandler"
      @select-all="tableSelectAllHandler"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="del(scope.row._id)">删除</el-button>
        </template>
      </el-table-column>-->
      <el-table-column label="单据同步日期">
        <template slot-scope="scope">{{timeFormat(scope.row.syncDate)}}</template>
      </el-table-column>
      <el-table-column label="会员数据日期">
        <template slot-scope="scope">{{voucherDate(scope.row)}}</template>
      </el-table-column>
      <el-table-column label="来源系统">
        <template slot-scope="scope">CRM</template>
      </el-table-column>
      <el-table-column prop="sourceShopCode" label="门店编码"></el-table-column>
      <el-table-column prop="sourceShopName" label="门店名称"></el-table-column>
    </el-table>
    <pagerBar
      ref="refPagerBar"
      :apiURL="VoucherDataApi"
      :GetData="getTableData"
      :queryParam="queryParam"
      :isInit="false"
      :errorFunc="errorHandler"
    ></pagerBar>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/common/config.js";
import pagerBar from "@/views/pager/pagerBar";
import AjaxHelper from "@/common/js/AjaxHelper";
export default {
  data() {
    return {
      isSearchVal: false,
      isVoucherCreate: false,
      queryParam: {},
      brandSel: true,
      storeSel: false,
      CurrnetMID: 0,
      deleteUrl: config.BASE_Middle_API + "orderManager/ChangeOrderRecords",
      VoucherManagerApi: config.BASE_Middle_API + "orderManager",
      VoucherDataApi: config.BASE_Middle_API + "orderManager/GetCrmOrderModels", //获取源数据接口 需提供
      Visible: false,
      optionsList: [],
      moduleList: [],
      brandList: [],
      brands: [],
      storesList: [],
      stores: [],
      tableData: [],
      accountList: [],
      selOrder: [],
      selOrderIds: [],
      time: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      voucherQueryModel: {
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
        brandID: "",
        storeID: "",
        storeCode: ""
      },
      selOrder: [],
      selOrderIds: [],
      multipeleSelectedIds: []
    };
  },
  props: {
    openloading: {
      type: Function,
      required: true
    },
    closeloading: {
      type: Function,
      required: true
    },
    tabType: {
      type: String,
      required: true
    }
  },
  components: { pagerBar },
  mounted() {
    this.getModules();
  },
  methods: {
    getRowKeys(row) {
      return row._id;
    },
    handleSelectionChange(val) {
      this.multipeleSelectedIds = val;
    },
    deleteBatch() {
      const _this = this;
      _this.multipeleSelectedIds.forEach(item => {
        _this.selOrderIds.push(item._id);
      });
      if (_this.selOrderIds.length == 0) {
        this.$notify({
          title: "提示",
          message: "请先勾选需要删除的单据",
          type: "error",
          position: "bottom-right"
        });
        return;
      }
      const confirmData = {
        brandID: _this.voucherQueryModel.brandID,
        orderIds: _this.selOrderIds
      };
      this.$confirm("确定删除凭证吗，请确保财务软件中已删除该凭证?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          AjaxHelper.post(_this.deleteUrl, {
            brandID: this.voucherQueryModel.brandID,
            orderIds: _this.selOrderIds
          }).then(function(r) {
            if (r.success) {
              _this.$message({
                type: "success",
                message: "删除成功!"
              });
              _this.$refs.tableData.clearSelection();
              _this.$refs.refPagerBar.Refresh();
            }
          });
        })
        .catch(e => {
          _this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    del(id) {
      const _this = this;
      this.$confirm(
        "确定删除该单据记录吗，请确保财务软件中已删除该单据?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }
      )
        .then(() => {
          AjaxHelper.delete(this.VoucherManagerApi + "/DeleteEntity", {
            brandID: this.voucherQueryModel.brandID,
            id: id
          }).then(function(r) {
            if (r.success) {
              _this.$message({
                type: "success",
                message: "删除成功!"
              });
              _this.$refs.refPagerBar.Refresh();
            }
          });
        })
        .catch(e => {
          _this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    voucherDate(val) {
      return `${moment(val.startTime).format("YYYY-MM-DD")}至${moment(
        val.endTime
      ).format("YYYY-MM-DD")}`;
    },
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    timeChange(val) {
      this.voucherQueryModel.startTime = moment(val[0]).format("YYYY-MM-DD");
      this.voucherQueryModel.endTime = moment(val[1]).format("YYYY-MM-DD");
    },
    errorHandler() {
      this.closeloading();
    },
    search() {
      this.openloading();
      let confirmData = Object.assign({}, this.voucherQueryModel);
      this.isSearchVal = true;
      if (this.voucherQueryModel.store == "") {
        let storeCode = [];
        let storeIDs = [];
        this.storesList.map(x => {
          storeCode.push(x.storeCode);
          storeIDs.push(x.id);
        });
        confirmData.storeCode = storeCode.join(",");
        confirmData.storeID = storeIDs.join(",");
      } else {
        const storeID = this.voucherQueryModel.storeID;
        const storeItem = this.storesList.filter(x => x.id == storeID);
        if (storeItem != null && storeItem.length > 0) {
          confirmData.storeCode = storeItem[0].storeCode;
        }
        confirmData.storeID = storeID;
      }
      this.queryParam = Object.assign({}, confirmData);
    },

    getAccount() {},
    getTableData(d) {
      this.tableData = d;
      console.log(d);
      this.closeloading();
    },
    storeChange() {
      this.storeSel = true;
    },
    brandChange(val) {
      this.brandSel = true;
      this.isSearchVal = false;
      this.storeSel = false;
      this.voucherQueryModel.storeID = "";
      this.voucherQueryModel.storeCode = "";
      this.storesList = this.stores.filter(x => x.brandID === val);
    },
    statusSearch(item) {
      this.storeSel = false;
      this.brandSel = false;
      this.CurrnetMID = item.id;
      this.voucherQueryModel.brandID = "";
      this.voucherQueryModel.storeID = "";
      this.voucherQueryModel.storeCode = "";
      this.brandList = this.brands.filter(x => x.moduleID == item.id);
      this.isSearchVal = false;
    },
    getModules() {
      const _this = this;
      AjaxHelper.get(_this.VoucherManagerApi + "/GetModules")
        .then(function(response) {
          if (response.success) {
            _this.moduleList = response.result.modules;
            if (_this.moduleList.length > 0) {
              const firstItem = _this.moduleList[0];
              _this.CurrnetMID = firstItem.id;
              _this.brands = response.result.brands;
              _this.stores = response.result.stores;
              _this.brands.forEach(x => {
                _this.moduleList.forEach(element => {
                  if (element.id == x.moduleID) {
                    // x.name = element.name + "/" + x.name;
                    _this.brandList.push(x);
                  }
                });
              });
            }
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
          console.log(error);
        });
    },
    // 选中table已有数据
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$nextTick(() => {
            let checked = this.tableData.find(
              tableRow => tableRow._id === row._id
            );
            this.$refs.tableData.toggleRowSelection(checked);
          });
        });
      } else {
        this.$refs.tableData.clearSelection();
      }
    },
    tableSelectHandler(selection, row) {
      const _this = this;
      let allRows = selection.filter(item => !!item);
      if (allRows.find(item => item._id === row._id)) {
        _this.addRows([row]);
      } else {
        _this.removeRows([row]);
      }
    },
    addRows(rows) {
      const _this = this;
      for (let key of rows) {
        if (!_this.selOrder.find(item => item._id === key._id)) {
          this.selOrder.push(key);
        }
      }
    },
    // 取消选中行
    removeRows(rows) {
      const _this = this;
      if (_this.selOrder.length > 0) {
        for (let row of rows) {
          _this.selOrder = _this.selOrder.filter(item => item._id !== row._id);
        }
      }
    },
    tableSelectAllHandler(selection) {
      //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
      selection.forEach((e, index) => {
        if (e === undefined) {
          selection.splice(index, 1);
        }
      });
      // 如果有则是全选否则就是全取消
      if (selection.length > 0) {
        this.addRows(this.tableData);
      } else {
        this.removeRows(this.tableData);
      }
    }
  }
};
</script>

<style scoped>
.minicard {
  height: auto !important;
  display: block;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 9989;
  top: 80px;
}
.minicard .el-button {
  width: 150px;
  margin: 5px 0;
}
.el-dialog__body {
  padding: 10px 15px !important;
}

dl.loglist p {
  font-weight: 600;
  margin: 20px 0 10px 0;
}
dl.loglist dd {
  padding: 15px 0;
  color: #999999;
  display: block;
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.w25 {
  width: 25%;
  float: left;
}
.w75 {
  width: 75%;
  float: left;
}
.el-card {
  border: 0;
  height: calc(100vh - 225px);
  overflow-y: auto;
}
.padding7 {
  padding: 7px;
}
.top7 {
  padding: 7px 0 0 0;
}
</style>